import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import LoadingSpinner from "../../components/LoadingSpinner";
import UserDetailView from "../../components/UserDetailView";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../services/api";

export default function StudentProfile() {
  const { user, checkAuth } = useAuth();
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    if (user) {
      setFormData({
        firstName: user.name?.first || "",
        lastName: user.name?.last || "",
        email: user.email || "",
        phone: user.phone || "",
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      await api.put(`/users/${user.id}/profile`, {
        phone: formData.phone,
      });
      toast.success("Profile updated successfully!");
      await checkAuth();
      setEditing(false);
    } catch (error) {
      toast.error(error.error || "Failed to update profile");
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return <LoadingSpinner size="lg" className="py-16" />;
  }

  return (
    <UserDetailView
      headerTitle="Student Profile"
      isNewUser={false}
      user={user}
      editing={editing}
      onEdit={() => setEditing(true)}
      onSave={handleSave}
      onCancel={() => setEditing(false)}
      formData={formData}
      onChange={handleChange}
      loading={loading}
      showStats={false}
      showStatus={false}
      canEdit={true}
      canResetPassword={false}
      isAdminForm={false}
    />
  );
}
